import { Icon } from "../../../../components/BaseComponents/Icon";

export const ExpandButtonIcon = (props) => (
	<Icon viewBox="0 0 12 7" {...props}>
		<path
			d="M938.388,129.719l-0.6-.6a0.378,0.378,0,0,0-.554,0l-4.732,4.732-4.732-4.732a0.378,0.378,0,0,0-.554,0l-0.6.6a0.38,0.38,0,0,0,0,.554l5.611,5.611a0.38,0.38,0,0,0,.554,0l5.611-5.611A0.38,0.38,0,0,0,938.388,129.719Z"
			transform="translate(-926.5 -129)"
			fill="currentColor"
			fillRule="evenodd"
		/>
	</Icon>
);
